<!-- 处理异常 -->
<template>
    <div>
        <div style="margin-left: 20px;">
            <HandleEx :detail="detail" ref="handleEx"></HandleEx>
        </div>
        <div style="padding-left: 160px;">
            <el-button type="primary" @click="save">{{ $t('integration.preservation') }}</el-button>
            <el-button type="primary" @click="cancel">{{ $t('integration.ir_cancel') }}</el-button>
        </div>
    </div>
</template>
<script>
import HandleEx from '@/pages/abnormal/component/HandleExDia/HandleEx.vue';
import { exHandle } from "@/api/modules/abnormal";

export default {
    props: ['exId', 'detail'],

  components: {
    HandleEx
  },
  data() {
    return {
    }
  },
  methods: {
    async save() {
        const data = await this.$refs['handleEx'].getData();
        const ids = this.detail.map(item => item.id);
        exHandle({
            exIds: ids,
            process: { ...data }
        }).then(({ result }) => {
            this.$refs['handleEx'].handleResult(result, () => {
                if (this.callback) {
                    this.callback();
                }
                if (this.$refs['handleEx']){
                  this.$refs['handleEx'].reset();
                }
                this.$emit('close')

            })
        })
    },
    cancel() {
      if (this.$refs['handleEx']){
        this.$refs['handleEx'].reset();
      }
      this.$emit('close')
    }
  },
}
</script>